module.exports = __webpack_public_path__ + "static/media/goods_title_en@2x.f618d6b7.png";